import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/element-variables.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video

ElementUI.Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
  return !(this.filterable || this.multiple || !isIE) && !this.visible
}

Vue.directive('removeAriaHidden', {
  bind (el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})

Vue.use(ElementUI)

Vue.prototype.$formatPrice = (value) => {
  if (typeof value === 'string' && !value.trim()) return '-'
  const num = Number(value)
  if (isNaN(num)) return '--'
  return num.toFixed(2)
}

// 捕获全局 JavaScript 错误
window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global error:', message, error)
  return true // 阻止默认行为
}

// 捕获未处理的 Promise 错误
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled Promise Rejection:', event.reason)
  event.preventDefault()
})

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
